import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';

const GalleryPage = () => {
  // Gallery images array - add your images here
  const galleryImages = [
    {
      id: 1,
      src: '/images/image12.jpeg',
      alt: 'Pet care at Raj Canine Care',
      title: 'Professional Care'
    },
    {
      id: 2,
      src: '/images/image2.jpeg',
      alt: 'Grooming services',
    },
    {
      id: 3,
      src: '/images/image3.jpeg',
      alt: 'Happy pets',
    },
    {
      id: 4,
      src: '/images/image4.jpeg',
      alt: 'Veterinary care',
    },
    {
      id: 5,
      src: '/images/image5.jpeg',
      alt: 'Pet shop',
    },
    {
      id: 6,
      src: '/images/image6.jpeg',
      alt: 'Facilities',
    },
    {
      id: 7,
      src: '/images/image7.jpeg',
      alt: 'Pet accessories',
    },
    {
      id: 8,
      src: '/images/image8.jpeg',
      alt: 'Dog grooming',
    },
    {
      id: 9,
      src: '/images/image9.jpeg',
      alt: 'Pet care team',
    },
    {
      id: 10,
      src: '/images/image10.jpeg',
      alt: 'Pet care team',
    },
    {
      id: 11,
      src: '/images/image11.jpeg',
      alt: 'Pet care team',
    },
    
  ];

  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="pt-20">
        <section className="py-20 bg-gradient-to-b from-blue-50 to-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              {/* Header */}
              <div className="text-center mb-12">
                <h1 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
                  Our Gallery
                </h1>
                <div className="w-24 h-1 bg-yellow-400 mx-auto mb-6"></div>
                <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                  Take a look at our facilities, happy pets, and the care we provide at Raj Canine Care
                </p>
              </div>

              {/* Gallery Grid */}
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {galleryImages.map((image) => (
                  <div
                    key={image.id}
                    className="overflow-hidden rounded-2xl shadow-lg"
                  >
                    <div className="aspect-square">
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          e.target.src = `https://via.placeholder.com/400?text=Gallery+Image`;
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default GalleryPage;
